import { AjaxService } from "../Helpers/AjaxService";
import { AreaSettings } from "../components/AreaSettings";
export class SettingsApi
{
    private static instance: SettingsApi;
    static getInstance() { return SettingsApi.instance || (SettingsApi.instance = new SettingsApi()); }
    private areaSetting: AreaSettings;
    constructor() {
        this.areaSetting = AreaSettings.getInstance();
    }
    getExpirationDate(): Promise<Date> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/settings/getExpirationDate?areaId=${this.areaSetting.areaId}`;
        return new Promise<Date>((resolve) => {
            ajaxService.get(apiUrl,
                (result: string) => {
                    resolve(new Date(parseInt(result.substr(6))));
                },null,"expirationDate");
        });
    }
}